import { useQueryClient } from '@tanstack/react-query'
import { useRef } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import type ReactSignatureCanvas from 'react-signature-canvas'

import { QUERY_KEYS } from '@/modules/shared/constants/query-keys.contant'
import { useResolveRequestHook } from '@/modules/shared/hooks/use-resolve-request.hook'
import { useMainStore } from '@/modules/shared/stores/main.store'
import { useOrderFormClearData } from '../../../hooks/use-order-form-clear-data.hook'
import { useOrderFormStore } from '../../../stores/order-form.store'
import { useOrderFormComponentStore, useOrderFormComponentStoreActions } from '../../../stores/order-form-component.store'
import { useSaveScheduleMutation } from '../../../mutations/save-schedule.mutation'

type ScheduleFormData = {
  observacao: string
  data: Date
}

export const useModalSchedulerComponent = () => {
  const signatureRef = useRef<ReactSignatureCanvas | null>(null)

  const navigate = useNavigate()
  const {
    initialLocationForOrder,
    actions: { setInitialLocationForOrder },
  } = useMainStore()

  const form = useForm<ScheduleFormData>()

  const queryClient = useQueryClient()

  const { clearAllDataOfOrder } = useOrderFormClearData()

  const { jsonOrderForm } = useOrderFormStore()
  const { isOpenModalSchedule } = useOrderFormComponentStore()
  const { setIsOpenModalSchedule } = useOrderFormComponentStoreActions

  const { checkStatusOnRequest } = useResolveRequestHook()

  const callbackSaveSchedule = () => {
    setIsOpenModalSchedule(false)
    clearAllDataOfOrder()

    queryClient.invalidateQueries({
      queryKey: [QUERY_KEYS.ORDERS],
    })
    if (initialLocationForOrder) {
      setInitialLocationForOrder(undefined)
      navigate('/clientes')
    } else {
      navigate('/pedidos')
    }
  }

  const { saveScheduleFn } = useSaveScheduleMutation({
    callback: callbackSaveSchedule,
    resolveRequest: checkStatusOnRequest,
  })

  const handleSaveSchedule = (data: ScheduleFormData) => {
    return saveScheduleFn({
      ...data,
      fkCliente: Number(jsonOrderForm?.fkCliente),
      fkUsuarioCel: jsonOrderForm?.fkUsuarioCel,
    })
  }

  const handleCloseModalSignature = () => {
    setIsOpenModalSchedule(false)
  }

  const handleCancelSchedule = () => {
    setIsOpenModalSchedule(false)

    clearAllDataOfOrder()

    if (initialLocationForOrder) {
      setInitialLocationForOrder(undefined)
      navigate('/clientes')
    } else {
      navigate('/pedidos')
    }
  }

  return {
    signatureRef,
    handleSaveSchedule,
    isOpenModalSchedule,
    handleCloseModalSignature,
    form,
    handleCancelSchedule,
  }
}
